import BlockEditor from './BlockEditor';

export default BlockEditor;
